export default{
  name:'MediasPortlet',
  field:'medias',
  props: {
    variant:'outlined',
   },
}